import InventoryIssueList from './InventoryIssueList';

export default InventoryIssueList;
